import { FC } from "react";
import { IonInput, IonItem, IonLabel } from "@ionic/react";
import { FieldErrors } from "react-hook-form";
import { errorProps } from "../services/errorService";

interface FormInputProps {
    title: string;
    registerName: string;
    errors: FieldErrors;
    register: Function;
    required: string | boolean;
    className?: string;
    min?: number;
}

const FormInputComponent: FC<FormInputProps> = ({
    title,
    registerName,
    errors,
    register,
    required,
    min,
    className,
    children,
}) => {
    return (
        <IonItem
            lines="full"
            {...errorProps(registerName, errors)}
            className={className}
        >
            <IonLabel>{title}</IonLabel>
            <IonInput
                {...register(registerName, {
                    required: required,
                    min: min,
                })}
            >
                {children}
            </IonInput>
        </IonItem>
    );
};
export default FormInputComponent;
